import {useEffect, useMemo} from "react";
import GraphicUtils from "../../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../../utils/report-utils.js";

export default function EncounterActions({ data }) {
    const allEncounterActionsChart = useMemo(() => {
        const source = data?.encounterActions || [];

        return {
            totalItems: source.length,
            labels: source.map(item => item.actions),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    const top10EncounterActions = useMemo(() => {
        const source = [...(data?.encounterActions || [])]
            .sort((a, b) => Number(b.qty || 0) - Number(a.qty || 0))
            .slice(0, 10);

        return {
            labels: source.map(item => item.actions),
            values: source.map(item => Number(item.qty || 0)),
        };
    }, [data]);

    const chartTitle = allEncounterActionsChart.totalItems > 10 ? "Ações decorrentes (TOP 10)" : "Ações decorrentes";

    useEffect(() => {
        GraphicUtils.barChart(
            "encounter-actions",
            top10EncounterActions.values,
            top10EncounterActions.labels,
        );

        if (allEncounterActionsChart.values.some(v => v > 0)) {
            ReportUtils.createExportableTable(
                allEncounterActionsChart.labels,
                allEncounterActionsChart.values,
                "Ações decorrentes",
            );
        }
    }, [allEncounterActionsChart, top10EncounterActions]);

    return (
        <>
            <div className="chart-report">
                <span className="chart-title">{chartTitle}</span>
                <div className="mt-3" id="encounter-actions" />
            </div>

            <div className="chart-divisor" />
        </>
    )
}